import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelectChange } from '@angular/material/select';
import { FilterDef } from '@common/data-models/navigation/filter-def';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { LayoutState } from '@common/services/layout-state';
import { FilterTypes } from '@src/suite/common/enums/filter-types';

@Component({
    selector: 'st-filter-list',
    templateUrl: './filter-list.html',
    styleUrls: ['./filter-list.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-filter-list',
    },
})
export class FilterListComponent {
    @Input() public filters: Array<FilterDef> = [];
    @Input() public isipad: boolean = false;
    @Input() public isnewviewstate: boolean = false;
    @Input() public disabled: boolean = false;

    @Input() filterType: FilterTypes;

    @Output() public update: EventEmitter<FilterDef> = new EventEmitter<FilterDef>();
    @Output() public remove: EventEmitter<FilterDef> = new EventEmitter<FilterDef>();

    constructor(
        public languageSettings: LanguageSettings,
        public globalTablesService: GlobalTablesService,
        public changeDetectorRef: ChangeDetectorRef,
        public layoutState: LayoutState
    ) {}

    public onSelectionChange(value: any, item: FilterDef) {
        if (value instanceof MatSelectChange) {
            value = value.value;
        }
        item.adjust(value);
    }

    public onOpenedChange(event: boolean, item: FilterDef) {
        if (!event) {
            item.onChanged();
            this.update.emit(item);
        }
    }

    public onChange(value: any, item: FilterDef) {
        if (this.isnewviewstate) {
            item.NotUsed = false;
        }
        item.Value = value;
        item.onChanged();
        this.update.emit(item);
    }

    public onBlankChange(event: MatCheckboxChange, item: FilterDef) {
        if (this.isnewviewstate) {
            item.NotUsed = false;
        }

        item.IsBlank = event.checked;
        this.onChange(item.Value, item);
    }

    public removeFilter(item: FilterDef) {
        this.remove.emit(item);
    }

    getTooltipLabel(item: string) {
        return `${this.languageSettings.PSTWebDeleteFilterLabel} ${item}`;
    }
}
